/* ============================================================
   SKINDAE — consolidated theme JS (deferred, event-delegated)
   ============================================================ */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ADD_URL = root + 'cart/add.js';
  var CART_URL = root + 'cart.js';

  function announce(msg) {
    var el = document.getElementById('status-announcement');
    if (el) el.textContent = msg;
  }

  /* ------------------------------------------------------------
     Cart drawer
     The Skindae buy buttons add over AJAX, then ask the theme's
     own cart drawer to open. We try the drawer element's public
     methods first and fall back to clicking whatever control the
     header uses to toggle it, so this keeps working regardless of
     the drawer's internal API.
     ------------------------------------------------------------ */
  function getCartDrawer() {
    return document.getElementById('cart-drawer');
  }

  function drawerIsOpen(drawer) {
    if (!drawer) return false;
    if (drawer.hasAttribute('open')) return true;
    if (drawer.getAttribute('aria-hidden') === 'false') return true;
    try {
      var cs = window.getComputedStyle(drawer);
      if (cs.visibility === 'hidden' || cs.display === 'none' || cs.opacity === '0') return false;
      return drawer.getBoundingClientRect().width > 0;
    } catch (err) {
      return false;
    }
  }

  function openCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) return false;
    if (drawerIsOpen(drawer)) return true;

    var methods = ['show', 'open', 'showDrawer'];
    for (var i = 0; i < methods.length; i++) {
      if (typeof drawer[methods[i]] === 'function') {
        try {
          drawer[methods[i]]();
          if (drawerIsOpen(drawer)) return true;
        } catch (err) {}
      }
    }

    var trigger = document.querySelector('[aria-controls="cart-drawer"]');
    if (trigger) {
      try { trigger.click(); return true; } catch (err) {}
    }
    return false;
  }

  /* UCIN mounts inside the cart drawer are replaced whenever the drawer
     re-renders. Nudge the UCIN SDK to scan again so the express checkout
     button comes back with the new cart contents. */
  function reinitUcin() {
    var api = window.UCIN || window.Ucin || window.ucin;
    if (!api) return;
    var hooks = ['refresh', 'rescan', 'scan', 'init', 'mount', 'render'];
    for (var i = 0; i < hooks.length; i++) {
      if (typeof api[hooks[i]] === 'function') {
        try { api[hooks[i]](); return; } catch (err) {}
      }
    }
  }

  function watchUcinMounts() {
    if (!window.MutationObserver) return;
    var pending = null;
    new MutationObserver(function (records) {
      var found = false;
      for (var i = 0; i < records.length && !found; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-ucin-checkout]')) { found = true; break; }
          if (node.querySelector && node.querySelector('[data-ucin-checkout]')) { found = true; break; }
        }
      }
      if (!found) return;
      clearTimeout(pending);
      pending = setTimeout(reinitUcin, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchUcinMounts);
  } else {
    watchUcinMounts();
  }

  function refreshCart(shouldOpenDrawer) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    fetch(CART_URL).then(function (r) { return r.json(); }).then(function (cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
      if (shouldOpenDrawer) setTimeout(openCartDrawer, 180);
    }).catch(function () {
      if (shouldOpenDrawer) setTimeout(openCartDrawer, 180);
    });
  }

  /* One code path for every add-to-cart on the site. `payload` is either a
     FormData (so line item properties, selling plans and quantity survive) or
     a plain object that gets sent as JSON. */
  function postAdd(payload, button, successLabel) {
    var original = button ? button.textContent : '';
    if (button) {
      button.textContent = 'Adding…';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    var init = { method: 'POST', headers: { Accept: 'application/json' } };
    if (payload instanceof FormData) {
      init.body = payload;
    } else {
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(payload);
    }

    function restore() {
      if (!button) return;
      button.textContent = original;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }

    return fetch(ADD_URL, init)
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (result) {
        if (button) button.textContent = successLabel || 'Added ✓';
        announce('Item added to your cart');
        refreshCart(true);
        setTimeout(restore, 1800);
        return result;
      })
      .catch(function (err) {
        if (button) {
          button.textContent = 'Try again';
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
        announce('Sorry, that could not be added to your cart');
        setTimeout(function () { if (button) button.textContent = original; }, 2200);
        throw err;
      });
  }

  function addItems(items, button, successLabel) {
    return postAdd({ items: items }, button, successLabel);
  }

  /* ------------------------------------------------------------
     Every add-to-cart form → AJAX + open the drawer

     This catches the product page, the home page product cards,
     collection cards and anything else that posts to /cart/add,
     which is what used to send shoppers to the full cart page.

     Deliberately conservative: if the theme's own code already
     handled the submit, if there is no drawer to open, or if the
     form has no variant id, we stand back and let the browser or
     the theme do exactly what it did before.
     ------------------------------------------------------------ */
  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;

    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form.hasAttribute('data-sk-native')) return;

    var action = form.getAttribute('action') || '';
    var isAddForm = form.id === 'sk-product-form' || action.indexOf('/cart/add') !== -1;
    if (!isAddForm) return;

    /* No drawer on this page (cart page, or cart type set to page) —
       leave the native behaviour alone rather than silently swallowing
       the click. */
    if (!getCartDrawer()) return;

    var button =
      form.querySelector('button[name="add"]') ||
      form.querySelector('.sk-btn-cart') ||
      form.querySelector('[type="submit"]');

    var data;
    try { data = new FormData(form); } catch (err) { return; }
    if (!data.get('id')) return;

    e.preventDefault();
    postAdd(data, button);
  });

  document.addEventListener('click', function (e) {
    /* ---- Ingredient tabs ---- */
    var itab = e.target.closest('[data-sk-ingtab]');
    if (itab) {
      var idx = itab.getAttribute('data-sk-ingtab');
      var wrap = itab.closest('.sk-ingtabs');
      if (wrap) {
        wrap.querySelectorAll('[data-sk-ingtab]').forEach(function (t) {
          t.classList.remove('on'); t.setAttribute('aria-selected', 'false');
        });
        itab.classList.add('on'); itab.setAttribute('aria-selected', 'true');
        wrap.querySelectorAll('[data-sk-ingpanel]').forEach(function (p) {
          var match = p.getAttribute('data-sk-ingpanel') === idx;
          p.hidden = !match;
          p.classList.toggle('on', match);
        });
      }
      return;
    }

    /* ---- Pack selector (1 / 2 / 3 units) ---- */
    var pack = e.target.closest('[data-sk-pack]');
    if (pack) {
      var qty = parseInt(pack.getAttribute('data-sk-pack'), 10) || 1;
      var group = pack.closest('.sk-packs');
      if (group) {
        group.querySelectorAll('[data-sk-pack]').forEach(function (p) {
          p.classList.remove('on'); p.setAttribute('aria-checked', 'false');
        });
      }
      pack.classList.add('on');
      pack.setAttribute('aria-checked', 'true');
      var qtyInput = document.getElementById('sk-qty-input');
      if (qtyInput) qtyInput.value = qty;
      var stickyBtn = document.querySelector('.sk-sticky-btn[data-sk-quick-add]');
      if (stickyBtn) stickyBtn.setAttribute('data-sk-qty-multiplier', qty);
      announce(qty + (qty === 1 ? ' unit selected' : ' units selected'));
      return;
    }

    /* ---- Quick add (also handles PDP matched-bundle "Add Kit to Cart") ---- */
    var qa = e.target.closest('[data-sk-quick-add]');
    if (qa) {
      e.preventDefault();
      var id = parseInt(qa.getAttribute('data-sk-quick-add'), 10);
      var mult = parseInt(qa.getAttribute('data-sk-qty-multiplier'), 10) || 1;
      if (id) addItems([{ id: id, quantity: mult }], qa);
      return;
    }

    /* ---- Add pair ---- */
    var pair = e.target.closest('[data-sk-add-pair]');
    if (pair) {
      e.preventDefault();
      var items = pair.getAttribute('data-sk-add-pair').split(',').map(function (v) {
        return { id: parseInt(v, 10), quantity: 1 };
      }).filter(function (i) { return i.id; });
      if (items.length) addItems(items, pair);
      return;
    }

    /* ---- Legacy UCIN button ----
       Kept only for any hand-placed [data-skindae-ucin] button. The
       'skindae-ucin' snippet now renders a real UCIN SDK mount instead. */
    var ucin = e.target.closest('[data-skindae-ucin]');
    if (ucin) {
      e.preventDefault();
      var url = ucin.getAttribute('data-ucin-url');
      var vid = ucin.getAttribute('data-variant-id');
      var qEl = document.getElementById('sk-qty-input');
      var q = qEl ? parseInt(qEl.value || '1', 10) : 1;
      var go = function () { window.location.href = url && url.length ? url : '/checkout'; };
      ucin.disabled = true;
      ucin.setAttribute('aria-busy', 'true');
      if (vid) {
        fetch(ADD_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: q }] })
        }).then(go).catch(go);
      } else { go(); }
      return;
    }

    /* ---- Gallery thumbnails ---- */
    var thumb = e.target.closest('[data-sk-thumb]');
    if (thumb) {
      var main = document.getElementById('sk-gal-img');
      if (main) main.src = thumb.getAttribute('data-sk-thumb');
      document.querySelectorAll('.sk-gal-thumb').forEach(function (t) {
        t.classList.remove('on'); t.setAttribute('aria-current', 'false');
      });
      thumb.classList.add('on');
      thumb.setAttribute('aria-current', 'true');
      return;
    }

    /* ---- YouTube facade ---- */
    var yt = e.target.closest('[data-sk-yt]');
    if (yt) {
      var vwrap = yt.closest('.sk-vid');
      var ytId = yt.getAttribute('data-sk-yt');
      if (vwrap && ytId) {
        var frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + ytId + '?autoplay=1&rel=0';
        frame.title = 'Product video';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture';
        frame.allowFullscreen = true;
        vwrap.innerHTML = '';
        vwrap.appendChild(frame);
      }
      return;
    }
  });

  /* ---- Variant picker sync ---- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('#sk-variant');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var money = opt.getAttribute('data-price');
    var now = document.getElementById('sk-price-now');
    if (now && money) now.textContent = money;
    var sp = document.getElementById('sk-sticky-price');
    if (sp && money) sp.textContent = money;
    document.querySelectorAll('[data-variant-id]').forEach(function (b) { b.setAttribute('data-variant-id', sel.value); });
    document.querySelectorAll('[data-ucin-variant-id]').forEach(function (b) { b.setAttribute('data-ucin-variant-id', sel.value); });
    document.querySelectorAll('[data-sk-quick-add]').forEach(function (b) { b.setAttribute('data-sk-quick-add', sel.value); });
  });
})();
